module.exports = __webpack_public_path__ + "img/img_32389_0_157.35a856a2.png";